import axiosInstanceV2 from "utils/InstanceAxios/InstanceAxiosV2";
import { Types } from "../reducers/pipelinesAccess";
import { pipelinesAccess } from "utils/consts/serverRoutes";
import errorMessages from 'utils/consts/errors';

//Synchronous
export const clearPipelineAccessRegister = () => {
  return (dispatch) => {
    dispatch({
      type: Types.CLEAR_PIPELINES_ACCESS_REGISTER,
    });
  };
};

//Asynchronous
export const createPipelineAccess = (pipelineAccess, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .post(pipelinesAccess.create(), pipelineAccess)
      .then((response) => {
        dispatch({
          type: Types.CREATE_PIPELINE_ACCESS,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        const message = (err.response?.data?.error || err.response?.data || err.message) || err.message;
        const errorMessage = errorMessages[message] || message;
        callback(false, errorMessage);
      });
  };
};

export const updatePipelineAccess = (pipelineAccessId, pipelineAccessData, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .put(pipelinesAccess.rud(`/${pipelineAccessId}`), pipelineAccessData)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_PIPELINE_ACCESS,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        const message = (err.response?.data?.error || err.response?.data || err.message) || err.message;
        const errorMessage = errorMessages[message] || message;
        callback(false, errorMessage);
      });
  };
};

export const getPipelineAccess = (pipelineAccessId) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    dispatch({
      type: Types.GET_PIPELINE_ACCESS,
      payload: null,
    });
    axiosInstanceV2
      .get(pipelinesAccess.rud(`/${pipelineAccessId}`))
      .then((response) => {
        dispatch({
          type: Types.GET_PIPELINE_ACCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_PIPELINE_ACCESS,
          payload: null,
        });
      });
  };
};

export const getAllPipelinesAccess = ( page, limit, sort = "", userId = "") => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_ALL_PIPELINES_ACCESS,
      payload: { pipelinesAccess: [], maxPages: 1 },
    });
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstanceV2
      .get(pipelinesAccess.getAll(`/${userId}`), { params: { page, limit, sort } })
      .then((response) => {
        dispatch({
          type: Types.GET_ALL_PIPELINES_ACCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_ALL_PIPELINES_ACCESS,
          payload: { pipelinesAccess: [], maxPages: 1 },
        });
      });
  };
};

export const deletePipelineAccess = (pipelineAccessId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstanceV2
      .delete(pipelinesAccess.rud(`/${pipelineAccessId}`))
      .then((response) => {
        dispatch({
          type: Types.DELETE_PIPELINE_ACCESS,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err)
        callback(false);
      })
  };
};


